/* Notif Visiteurs en Direct - affichage unique par page */
(function () {
  var citiesArray = [
    'Paris','Lyon','Marseille','Bordeaux','Toulouse','Lille','Nice','Nantes',
    'Strasbourg','Rennes','Grenoble','Rouen','Toulon','Montpellier','Nancy',
    'Dijon','Reims','Brest','Perpignan','Amiens','Le Havre','Annecy',
    'Chambéry','Lorient','Troyes','Genève','Aix-en-Provence','Cannes',
    'Antibes','Metz','Caen','Clermont-Ferrand','Orléans','Angers','Pau'
  ];

  var displayDurationMs = 5000;

  function showViewer() {
    var box = document.getElementById('live-viewer-box');
    if (!box) return;

    var randomCity = citiesArray[Math.floor(Math.random() * citiesArray.length)];
    var cityEl = box.querySelector('.viewer-city');
    if (cityEl) cityEl.textContent = randomCity;

    box.style.transition = 'visibility 0s, opacity 0.5s linear';
    box.style.visibility = 'visible';
    box.style.opacity = '1';

    setTimeout(function () {
      box.style.transition = 'visibility 1s, opacity 0.5s linear';
      box.style.visibility = 'hidden';
      box.style.opacity = '0';
    }, displayDurationMs);
  }

  // Apparaît une seule fois, 8 secondes après le chargement
  setTimeout(showViewer, 8000);

})();
